<template>
  <div class="columns" flex direction="column" rowgap="1.5rem">
    <sp-fieldset class="context-menu__fieldset">
      <sp-label for="columns">Columns</sp-label>
      <InputRangeSlider
        v-model.number="numberOfColumns"
        min="1"
        max="12"
        step="1"
        show-ticks
        value-and-unit-width="6ch"
      />
    </sp-fieldset>
    <Column v-for="(column, index) in columns" :key="column.id" :model-value="column" :index="index" />
  </div>
</template>

<script setup>
import { watchDeep } from "@vueuse/core";
import { computed, ref } from "vue";
import { randomUUID } from "#/shared/utils/string";
import InputRangeSlider from "#ce/components/SpLayoutBuilder/components/LayoutBuilderContextMenu/InputRangeSlider.ce.vue";
import Column from "./ConfigurationColumn.ce.vue";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
});

const columns = ref();
watchDeep(
  () => props.modelValue,
  (newVal) => (columns.value = newVal),
  { immediate: true },
);
watchDeep(columns, (newVal) => emit("update:modelValue", newVal));

const numberOfColumns = computed({
  get: () => columns.value.length,
  set: (value) => recalculateColumns(value),
});

function recalculateColumns(numberOfColumns) {
  const newColumns = [...columns.value].slice(0, numberOfColumns);

  // Fill up missing columns
  for (let i = newColumns.length; i < numberOfColumns; i++) {
    newColumns.push({ id: randomUUID() });
  }

  columns.value = newColumns;
}
</script>

<style lang="scss" scoped>
.columns {
  &.--invalid {
    outline: 1px solid red;
  }
}

sp-fieldset.context-menu__fieldset.--column-settings {
  display: flex;
  flex-direction: column;
  gap: var(--sp-ref-scale-16);
  padding: var(--sp-ref-scale-24);
  border: 1px solid var(--sp-comp-context-menu-fieldset-border-color, #ccc);
  border-radius: var(--sp-comp-context-menu-fieldset-border-radius, 0.25rem);
  margin-top: var(--sp-ref-scale-32);
  box-sizing: border-box;
  position: relative;
}
</style>
